import {
  ExternalDeliverySettings,
  ExternalDeliverySettingsForm,
  OrderProcessingConfig,
  OrderProcessingConfigForm,
  POSType,
} from 'api/ordering-service/ordering-service.types';

export const transformOrderProcessingConfigForResponse = (
  orderProcessingConfig: OrderProcessingConfig,
): OrderProcessingConfigForm => {
  return {
    ...orderProcessingConfig,
    externalDeliverySettingsEnabled:
      !!orderProcessingConfig?.externalDeliverySettings
        ? orderProcessingConfig?.externalDeliverySettings?.deliveryStrategy !==
          'INCENTIVIO'
        : false,
    externalDeliverySettings: transformExternalDeliverySettingsForResponse(
      orderProcessingConfig?.externalDeliverySettings,
    ),
  };
};

export const transformExternalDeliverySettingsForResponse = (
  externalDeliverySettings: ExternalDeliverySettings,
): ExternalDeliverySettingsForm => {
  return {
    ...externalDeliverySettings,
    externalDeliveryFeeStrategy:
      externalDeliverySettings?.externalDeliveryFeeStrategy === 'ADD',
    contactPhone:
      !externalDeliverySettings?.contactPhone ||
      externalDeliverySettings?.contactPhone.startsWith('+1')
        ? externalDeliverySettings?.contactPhone
        : `+1${externalDeliverySettings.contactPhone}`,
  };
};

export const transformOrderProcessingConfigForRequest = (
  orderProcessingConfig: OrderProcessingConfigForm,
  posType: POSType,
): OrderProcessingConfig => {
  return {
    ...orderProcessingConfig,
    orderGatewayName: posType,
    calculationStrategy: orderProcessingConfig.calculationStrategy || null,
    orderProcessingStrategy:
      orderProcessingConfig.orderProcessingStrategy || null,
    paymentIDGenerationStrategy:
      orderProcessingConfig.paymentIDGenerationStrategy || null,
    paymentGatewayName: orderProcessingConfig.paymentGatewayName || null,
    roundingMode: orderProcessingConfig.roundingMode || null,
    externalDeliverySettings: transformExternalDeliverySettingsForRequest(
      orderProcessingConfig.externalDeliverySettings,
      orderProcessingConfig.externalDeliverySettingsEnabled,
    ),
  };
};

export const transformExternalDeliverySettingsForRequest = (
  externalDeliverySettings: ExternalDeliverySettingsForm,
  enabled: boolean,
): ExternalDeliverySettings => {
  return {
    ...externalDeliverySettings,
    deliveryStrategy: enabled
      ? externalDeliverySettings.deliveryStrategy
      : 'INCENTIVIO',
    externalDeliveryFeeStrategy:
      externalDeliverySettings.externalDeliveryFeeStrategy ? 'ADD' : 'IGNORE',
  };
};
